<template>
  <modal :title="$t('public.carrier_data_detail')"
     :visible.sync="isShowDialog" width="1000px" @close="close">

     <el-tabs type='card' v-model='tab' @tab-click="handleTabClick">
      <el-tab-pane :label="$t('public.data_timely_rate')" name='timelyRate'>
        <div>
          <div class="uk-flex mb-10">
            <el-select v-model="timelyParams.time" :disabled="isShowTimelyCompareTable">
              <el-option
                v-for="item in yearList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="timelySelectScenes" multiple class="ml-10">
              <el-option
                v-for="item in scenesList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
            <el-input
              :placeholder="$t('public.table_carrier_name')"
              v-model="timelyParams.carrierName"
              clearable
              style="width:300px;margin-right: 30px;"
              class="ml-10">
            </el-input>
            <el-button type="primary" @click="searchTimelyRate">{{ $t('public.search')}}</el-button>
          </div>
          <!-- 数据对比的table -->
          <el-table
            v-if="isShowTimelyCompareTable"
            :data="timelyCompareList"
            border
            v-loading='timelyLoading'
            :span-method="objectSpanMethod"
          >
            <el-table-column
              :label="$t('public.carrier')"
              width="180"
              prop="carrierName"
              >
            </el-table-column>
            <el-table-column
              :label="$t('public.carrier_type')"
              width="180"
              >
              <template  slot-scope="scope">
                <span>{{ $t(carrierTypeConvert(scope.row.typeId).title) }}</span>
              </template>
            </el-table-column>
            <!-- 所属 -->
            <el-table-column
              prop="sceneName"
              :label="$t('public.belong')"
            >
            </el-table-column>
            <el-table-column
              prop="year"
              :label="$t('integration.year_2')"
            >
            </el-table-column>
            <el-table-column
              v-for="(item, index) in timelyCompareDynamicColumns"
              :key="index"
            >
              <template slot="header">
                <span>{{ item }}</span>
              </template>
              <template  slot-scope="scope">
                <span v-if="!scope.row.carrierDataList[index] || !scope.row.carrierDataList[index].sum"> - </span>
                <span v-else>
                  {{ ((scope.row.carrierDataList[index].sum / scope.row.carrierDataList[index].count) * 100).toFixed(1) }}%
                  <i v-if="scope.row.carrierDataList[index].arrow === 'top'" class="el-icon-top color-green"></i>
                  <i v-if="scope.row.carrierDataList[index].arrow === 'bottom'" class="el-icon-bottom color-red"></i>
                </span>
              </template>
            </el-table-column>

          </el-table>

          <!-- 单个年份的table -->
          <el-table
            v-else
            :data="timelyRateList"
            border
            v-loading='timelyLoading'
          >
            <el-table-column
              :label="$t('public.carrier')"
              width="180"
              prop="carrierName"
              >
            </el-table-column>
            <el-table-column
              :label="$t('public.carrier_type')"
              width="180"
              >
              <template  slot-scope="scope">
                <span>{{ $t(carrierTypeConvert(scope.row.typeId).title) }}</span>
              </template>
            </el-table-column>
            <!-- 所属 -->
            <el-table-column
              prop="sceneName"
              :label="$t('public.belong')"
            >
            </el-table-column>
            <!-- <el-table-column
              v-for="(item, index) in dynamicColumns"
              :key="index"
              prop="count"
              :label="item.label"
            >
            <template  slot-scope="scope">
                <span>{{ scope.row.count }}</span>
              </template>
            </el-table-column> -->

            <el-table-column
              v-for="(item, index) in timelyDynamicColumns"
              :key="index"
            >
              <template slot="header">
                <span>{{ item }}</span>
              </template>
              <template  slot-scope="scope">
                <span v-if="!scope.row.carrierDataList[index] || !scope.row.carrierDataList[index].sum"> - </span>
                <span v-else>{{ ((scope.row.carrierDataList[index].sum / scope.row.carrierDataList[index].count) * 100).toFixed(1) }}%</span>
              </template>
            </el-table-column>
          </el-table>

          <!-- 数据同比 -->
          <div class="mt-5">
            <el-checkbox v-model="timelyCompareChecked" style="margin-right:20px;">{{ $t('public.data_year_on_year') }}</el-checkbox>
            <span :class="{'color-gray': !timelyCompareChecked}"> {{ $t('integration.year_on_year') }} </span>
            <el-select v-model="timelyCompareYear"
              :disabled="!timelyCompareChecked"
              @change="timelyCompareChange">
              <el-option
                v-for="item in yearList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.value === timelyParams.time">
              </el-option>
            </el-select>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('public.data_standard_rate')" name='standardRate'>
        <div>
          <div class="uk-flex mb-10">
            <el-select v-model="standardParams.time" :disabled="isShowStandardCompareTable">
              <el-option
                v-for="item in yearList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="standardSelectScenes" multiple class="ml-10">
              <el-option
                v-for="item in scenesList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
            <el-input
              :placeholder="$t('public.table_carrier_name')"
              v-model="standardParams.carrierName"
              clearable
              style="width:300px;margin-right: 30px;"
              class="ml-10">
            </el-input>
            <el-button type="primary" @click="searchStandardRate">{{ $t('public.search')}}</el-button>
          </div>
          <!-- 数据对比的table -->
          <el-table
            v-if="isShowStandardCompareTable"
            :data="standardCompareList"
            border
            v-loading='standardLoading'
            :span-method="objectSpanMethod2"
          >
            <el-table-column
              :label="$t('public.carrier')"
              width="180"
              prop="carrierName"
              >
            </el-table-column>
            <el-table-column
              :label="$t('public.carrier_type')"
              width="180"
              >
              <template  slot-scope="scope">
                <span>{{ $t(carrierTypeConvert(scope.row.typeId).title) }}</span>
              </template>
            </el-table-column>
            <!-- 所属 -->
            <el-table-column
              prop="sceneName"
              :label="$t('public.belong')"
            >
            </el-table-column>
            <el-table-column
              prop="year"
              :label="$t('integration.year_2')"
            >
            </el-table-column>
            <el-table-column
              v-for="(item, index) in standardCompareDynamicColumns"
              :key="index"
            >
              <template slot="header">
                <span>{{ item }}</span>
              </template>
              <template  slot-scope="scope">
                <span v-if="!scope.row.carrierDataList[index] || !scope.row.carrierDataList[index].sum"> - </span>
                <span v-else>
                  {{ ((scope.row.carrierDataList[index].sum / scope.row.carrierDataList[index].count) * 100).toFixed(1) }}%
                  <i v-if="scope.row.carrierDataList[index].arrow === 'top'" class="el-icon-top color-green"></i>
                  <i v-if="scope.row.carrierDataList[index].arrow === 'bottom'" class="el-icon-bottom color-red"></i>
                </span>
              </template>
            </el-table-column>

          </el-table>

          <!-- 单个年份的table -->
          <el-table
            v-else
            :data="standardRateList"
            border
            v-loading='standardLoading'
          >
            <el-table-column
              :label="$t('public.carrier')"
              width="180"
              prop="carrierName"
              >
            </el-table-column>
            <el-table-column
              :label="$t('public.carrier_type')"
              width="180"
              >
              <template  slot-scope="scope">
                <span>{{ $t(carrierTypeConvert(scope.row.typeId).title) }}</span>
              </template>
            </el-table-column>
            <!-- 所属 -->
            <el-table-column
              prop="sceneName"
              :label="$t('public.belong')"
            >
            </el-table-column>
            <el-table-column
              v-for="(item, index) in standardDynamicColumns"
              :key="index"
            >
              <template slot="header">
                <span>{{ item }}</span>
              </template>
              <template  slot-scope="scope">
                <span v-if="!scope.row.carrierDataList[index] || !scope.row.carrierDataList[index].sum"> - </span>
                <span v-else>{{ ((scope.row.carrierDataList[index].sum / scope.row.carrierDataList[index].count) * 100).toFixed(1) }}%</span>
              </template>
            </el-table-column>
          </el-table>
          <!-- 数据同比 -->
          <div class="mt-5">
            <el-checkbox v-model="standardCompareChecked" style="margin-right:20px;">{{ $t('public.data_year_on_year') }}</el-checkbox>
            <span :class="{'color-gray': !standardCompareChecked}"> {{ $t('integration.year_on_year') }} </span>
            <el-select v-model="standardCompareYear"
               :disabled="!standardCompareChecked"
               @change="standardCompareChange">
              <el-option
                v-for="item in yearList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.value === standardParams.time">
              </el-option>
            </el-select>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

  </modal>
</template>
<script>
import { getTimelyRate, getStandardRate } from '@/api/modules/overview.js'
import { sensorType, sensorTypeConvert } from '@/utils/dict/sensor'
import { deviceTypeConvert, deviceStatusConvert, carrierTypeConvert} from '@/utils/convert.js'
import BarEchart from '@/components/echart/barEchart.vue';
import getRange from '@/utils/getRange.js';

export default {
  mixins: [ getRange ],
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    sceneIds: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: ''
    }
  },
  components: {
    BarEchart,
  },
  data(){
    return {
      timelyRateList: [],
      standardRateList: [],
      // currYear: new Date().getFullYear(), //当前年份
      tab: 'timelyRate',
      totalList: [], // 总的数据

      timelyDynamicColumns: [], //要动态显示的列
      standardDynamicColumns: [],

      timelyParams: {
         time: new Date().getFullYear(),
         carrierName: '',
         scenes: ''
      },
      timelyLoading: false,
      timelySelectScenes: [],

      standardParams: {
         time: new Date().getFullYear(),
         carrierName: '',
         scenes: ''
      },
      standardLoading: false,
      standardSelectScenes: [],

      timelyCompareYear: '',
      standardCompareYear: '',
      timelyCompareChecked: false, // 是否开启数据同比
      standardCompareChecked: false,

      timelyCompareList: [], // 数据对比的table数据
      standardCompareList: [], // 数据对比的table数据

      timelyCompareDynamicColumns: [], //要动态显示的列
      standardCompareDynamicColumns: [], //要动态显示的列

      spanArr: [], // 数据对比table数据要合并的单元格
      pos: 0,
      standardSpanArr: [],
      standardPos: 0,

      sensorTypeConvert,
      deviceTypeConvert,
      carrierTypeConvert,

      scenesList: []
    }
  },
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShow
      },
      set: function (val) {
        this.$emit('update:isShow', val) // 可以优化成model  或者minx
      }
    },
    yearList(){
      let cur = new Date().getFullYear()
      let arr = []
      for(let i=cur; i>cur-5; i--){
        arr.push({
          value: i,
          label: i + $t('integration.year')
        })
      }
      return arr
    },
    // 显示数据对比的表格
    isShowTimelyCompareTable(){
      return (this.timelyCompareChecked && this.timelyCompareYear) ? true : false
    },
    // 显示数据对比的表格
    isShowStandardCompareTable(){
      return (this.standardCompareChecked && this.standardCompareYear) ? true : false
    }
  },
  watch: {
    timelyCompareChecked(val){
      if(!val){
        this.timelyCompareYear = ''
        this.timelyCompareList = []
      }
    },
    standardCompareChecked(val){
      if(!val){
        this.standardCompareYear = ''
        this.standardCompareList = []
      }
    }
  },
  created(){
    this.timelyParams.scenes = this.sceneIds.join()
    this.standardParams.scenes = this.sceneIds.join()
    this.timelySelectScenes = this.sceneIds
    this.standardSelectScenes = this.sceneIds
    this.getDataTimelyRate()
    this.getDataStandardRate()
    this.getCustomer()
  },
  methods: {
    // 数据上报及时率
    getDataTimelyRate(){
      this.timelyLoading = true
      getTimelyRate(this.timelyParams).then(res => {
         this.timelyLoading = false
        if (res.state.code === 200) {
          this.timelyRateList = res.result
          // 构建要动态显示的列
          let lengthArr = []
          res.result.forEach(item => {
           lengthArr.push(item.carrierDataList.length)
          })
          lengthArr.sort((a, b) => a-b)
          const max = lengthArr[lengthArr.length - 1]

          this.timelyDynamicColumns = []
          for(let i=1; i<=max; i++){
            this.timelyDynamicColumns.push( i + $t('integration.month'))
          }

        }
      })
    },
    // 数据上报达标率
    getDataStandardRate(){
      this.standardLoading = true
      getStandardRate(this.standardParams).then(res => {
        this.standardLoading = false
        if (res.state.code === 200) {
          this.standardRateList = res.result

          let lengthArr = []
          res.result.forEach(item => {
           lengthArr.push(item.carrierDataList.length)
          })
          lengthArr.sort((a, b) => a-b)
          const max = lengthArr[lengthArr.length - 1]

          this.standardDynamicColumns = []
          for(let i=1; i<=max; i++){
            this.standardDynamicColumns.push( i + $t('integration.month'))
          }
        }
      })
    },
    close(){
      this.$emit('close')
    },
    handleTabClick(){

    },
    searchTimelyRate(){
      this.timelyParams.scenes = this.timelySelectScenes.join()
      this.getDataTimelyRate()
    },
    searchStandardRate(){
      this.standardParams.scenes = this.standardSelectScenes.join()
      this.getDataStandardRate()
    },
    // 数据上报及时率的数据对比
    timelyCompareChange(){
      // 当前搜索框的年份
      let currYear = this.timelyParams.time
      this.timelyLoading = true

      this.timelyCompareList = []
      // this.timelyRateList.forEach(item => {
      //   // this.timelyCompareList.push({
      //   //   carrierId: item.carrierId,
      //   //   carrier_name: item.carrier_name,
      //   //   typeId: item.typeId,
      //   //   carrierDataList: {
      //   //     [currYear]: item.carrierDataList
      //   //   }

      //   // })
      //   this.timelyCompareList.push({
      //     ...item,
      //     year: currYear

      //   })
      // })
      console.log('timelyCompareList==', this.timelyCompareList)
      let params = {
        ...this.timelyParams,
        time: this.timelyCompareYear
      }
      getTimelyRate(params).then(res => {
         this.timelyLoading = false
        if (res.state.code === 200) {

          // 年份大的在前面
          if(currYear > this.timelyCompareYear){

            // 先两个list的数据对比求出数据是上升还是下降

            this.timelyRateList.forEach(item1 => {
              this.timelyCompareList.push({
                ...item1,
                year: currYear

              })
            })
            res.result.forEach(item2 => {
              //  let index = this.timelyCompareList.findIndex(_ => _.carrierId === item.carrierId)
              //  if(index === -1){
              //    this.timelyCompareList.push({
              //       carrierId: item.carrierId,
              //       carrier_name: item.carrier_name,
              //       typeId: item.typeId,
              //       carrierDataList: {
              //         [this.timelyCompareYear]: item.carrierDataList
              //       }

              //     })
              //  }else{
              //    this.timelyCompareList[index].carrierDataList[this.timelyCompareYear] = item.carrierDataList
              //  }

              let index = this.timelyCompareList.findIndex(_ => _.carrierId === item2.carrierId)
              if(index === -1){
                this.timelyCompareList.push({
                  ...item2,
                  year: this.timelyCompareYear
                })
              }else{
                this.timelyCompareList.splice(index+1, 0, {
                  ...item2,
                  year: this.timelyCompareYear
                })

                // 判断数据是上升还是下降
                if(this.timelyCompareList[index].carrierDataList.length){
                  if(item2.carrierDataList.length){
                    this.timelyCompareList[index].carrierDataList.forEach((data, dIndex) => {
                      if(data.sum){
                        if(item2.carrierDataList[dIndex] && item2.carrierDataList[dIndex].sum){
                          let percentage1 = ((data.sum / data.count) * 100).toFixed(1)
                          let percentage2 = ((item2.carrierDataList[dIndex].sum / item2.carrierDataList[dIndex].count) * 100).toFixed(1)
                          if(percentage1 !== percentage2){
                            if(percentage1 > percentage2){
                              data.arrow = 'top'
                            }else{
                              data.arrow = 'bottom'
                            }
                          }
                        }else{
                          data.arrow = 'top'
                        }
                      }else{
                         if(item2.carrierDataList[dIndex].sum){
                          data.arrow = 'bottom'
                        }
                      }
                    })
                  }else{
                    this.timelyCompareList[index].carrierDataList.forEach((data, dIndex) => {
                      if(data.sum){
                        data.arrow = 'top'
                      }
                    })
                  }
                }

              }

            })
          }else{
            res.result.forEach(item3 => {
              this.timelyCompareList.push({
                ...item3,
                year: this.timelyCompareYear

              })
            })
             this.timelyRateList.forEach(item4 => {
              let index2 = this.timelyCompareList.findIndex(_ => _.carrierId === item4.carrierId)
              if(index2 === -1){
                this.timelyCompareList.push({
                  ...item4,
                  year: currYear
                })
              }else{
                this.timelyCompareList.splice(index2+1, 0, {
                  ...item4,
                  year: currYear
                })

                // 判断数据是上升还是下降
                if(this.timelyCompareList[index2].carrierDataList.length){
                  if(item4.carrierDataList.length){
                    this.timelyCompareList[index2].carrierDataList.forEach((data, dIndex) => {
                      if(data.sum){
                        if(item4.carrierDataList[dIndex] && item4.carrierDataList[dIndex].sum){
                          let percentage1 = ((data.sum / data.count) * 100).toFixed(1)
                          let percentage2 = ((item4.carrierDataList[dIndex].sum / item4.carrierDataList[dIndex].count) * 100).toFixed(1)
                          if(percentage1 !== percentage2){
                            if(percentage1 > percentage2){
                              data.arrow = 'top'
                            }else{
                              data.arrow = 'bottom'
                            }
                          }
                        }else{
                          data.arrow = 'top'
                        }
                      }else{
                         if(item4.carrierDataList[dIndex].sum){
                          data.arrow = 'bottom'
                        }
                      }
                    })
                  }else{
                    this.timelyCompareList[index2].carrierDataList.forEach((data, dIndex) => {
                      if(data.sum){
                        data.arrow = 'top'
                      }
                    })
                  }
                }

              }

            })
          }



          console.log('timelyCompareList=222222=', this.timelyCompareList)


          // 构建要动态显示的列
          let lengthArr = []
          this.timelyCompareList.forEach(item => {
           lengthArr.push(item.carrierDataList.length)
          })
          lengthArr.sort((a, b) => a-b)
          const max = lengthArr[lengthArr.length - 1]
          console.log('lengthArr==', lengthArr, max)

          this.timelyCompareDynamicColumns = []
          for(let i=1; i<=max; i++){
            this.timelyCompareDynamicColumns.push( i + $t('integration.month'))
          }

          this.getSpanArr();//后台获取到数据后进行数据处理


        }
      })
    },

    // 合并单元格的逻辑
    getSpanArr(){
      this.spanArr = [] // 用于存放每一行记录的合并数
      for(let i=0; i<this.timelyCompareList.length; i++){
        if(i === 0){
          // for(let j=0; j<this.colLength; j++){
          //   this.spanArr[j] = {
          //     rowspan: 1,
          //     colspan: 1
          //   }
          // }


          this.spanArr.push(1);
          this.pos = 0
        }else{
          // for(let j=0; j<this.colLength; j++){
          //   if(this.timelyCompareList[i][j] === this.timelyCompareList[i-1][j]){
          //     this.spanArr[i * this.colLength + j ] = {
          //       rowspan: 2,
          //       colspan: 1
          //     }
          //   }else{
          //     this.spanArr[i * this.colLength + j ] = {
          //       rowspan: 1,
          //       colspan: 1
          //     }
          //   }
          // }
          if (this.timelyCompareList[i].carrierId === this.timelyCompareList[i - 1].carrierId) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = i;
          }
        }
      }
      console.log('this.spanArr==', this.spanArr)
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if(columnIndex===0 || columnIndex===1 || columnIndex===2){
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        }
      }
      // return this.spanArr[rowIndex * this.colLength + columnIndex]
    },

    // 数据上报达标率的数据对比
    standardCompareChange(){
      // 当前搜索框的年份
      let currYear = this.standardParams.time
      this.standardLoading = true

      this.standardCompareList = []
      // this.standardRateList.forEach(item => {
      //   // this.standardCompareList.push({
      //   //   carrierId: item.carrierId,
      //   //   carrier_name: item.carrier_name,
      //   //   typeId: item.typeId,
      //   //   carrierDataList: {
      //   //     [currYear]: item.carrierDataList
      //   //   }

      //   // })
      //   this.standardCompareList.push({
      //     ...item,
      //     year: currYear

      //   })
      // })
      console.log('standardCompareList==', this.standardCompareList)
      let params = {
        ...this.standardParams,
        time: this.standardCompareYear
      }
      getStandardRate(params).then(res => {
         this.standardLoading = false
        if (res.state.code === 200) {

          // 年份大的在前面
          if(currYear > this.standardCompareYear){

            // 先两个list的数据对比求出数据是上升还是下降

            this.standardRateList.forEach(item1 => {
              this.standardCompareList.push({
                ...item1,
                year: currYear

              })
            })
            res.result.forEach(item2 => {
              //  let index = this.standardCompareList.findIndex(_ => _.carrierId === item.carrierId)
              //  if(index === -1){
              //    this.standardCompareList.push({
              //       carrierId: item.carrierId,
              //       carrier_name: item.carrier_name,
              //       typeId: item.typeId,
              //       carrierDataList: {
              //         [this.standardCompareYear]: item.carrierDataList
              //       }

              //     })
              //  }else{
              //    this.standardCompareList[index].carrierDataList[this.standardCompareYear] = item.carrierDataList
              //  }

              let index = this.standardCompareList.findIndex(_ => _.carrierId === item2.carrierId)
              if(index === -1){
                this.standardCompareList.push({
                  ...item2,
                  year: this.standardCompareYear
                })
              }else{
                this.standardCompareList.splice(index+1, 0, {
                  ...item2,
                  year: this.standardCompareYear
                })

                // 判断数据是上升还是下降
                if(this.standardCompareList[index].carrierDataList.length){
                  if(item2.carrierDataList.length){
                    this.standardCompareList[index].carrierDataList.forEach((data, dIndex) => {
                      if(data.sum){
                        if(item2.carrierDataList[dIndex] && item2.carrierDataList[dIndex].sum){
                          let percentage1 = ((data.sum / data.count) * 100).toFixed(1)
                          let percentage2 = ((item2.carrierDataList[dIndex].sum / item2.carrierDataList[dIndex].count) * 100).toFixed(1)
                          if(percentage1 !== percentage2){
                            if(percentage1 > percentage2){
                              data.arrow = 'top'
                            }else{
                              data.arrow = 'bottom'
                            }
                          }
                        }else{
                          data.arrow = 'top'
                        }
                      }else{
                         if(item2.carrierDataList[dIndex].sum){
                          data.arrow = 'bottom'
                        }
                      }
                    })
                  }else{
                    this.standardCompareList[index].carrierDataList.forEach((data, dIndex) => {
                      if(data.sum){
                        data.arrow = 'top'
                      }
                    })
                  }
                }

              }

            })
          }else{
            res.result.forEach(item3 => {
              this.standardCompareList.push({
                ...item3,
                year: this.standardCompareYear

              })
            })
             this.standardRateList.forEach(item4 => {
              let index2 = this.standardCompareList.findIndex(_ => _.carrierId === item4.carrierId)
              if(index2 === -1){
                this.standardCompareList.push({
                  ...item4,
                  year: currYear
                })
              }else{
                this.standardCompareList.splice(index2+1, 0, {
                  ...item4,
                  year: currYear
                })

                // 判断数据是上升还是下降
                if(this.standardCompareList[index2].carrierDataList.length){
                  if(item4.carrierDataList.length){
                    this.standardCompareList[index2].carrierDataList.forEach((data, dIndex) => {
                      if(data.sum){
                        if(item4.carrierDataList[dIndex] && item4.carrierDataList[dIndex].sum){
                          let percentage1 = ((data.sum / data.count) * 100).toFixed(1)
                          let percentage2 = ((item4.carrierDataList[dIndex].sum / item4.carrierDataList[dIndex].count) * 100).toFixed(1)
                          if(percentage1 !== percentage2){
                            if(percentage1 > percentage2){
                              data.arrow = 'top'
                            }else{
                              data.arrow = 'bottom'
                            }
                          }
                        }else{
                          data.arrow = 'top'
                        }
                      }else{
                         if(item4.carrierDataList[dIndex].sum){
                          data.arrow = 'bottom'
                        }
                      }
                    })
                  }else{
                    this.standardCompareList[index2].carrierDataList.forEach((data, dIndex) => {
                      if(data.sum){
                        data.arrow = 'top'
                      }
                    })
                  }
                }

              }

            })
          }



          console.log('standardCompareList=222222=', this.standardCompareList)


          // 构建要动态显示的列
          let lengthArr = []
          this.standardCompareList.forEach(item => {
           lengthArr.push(item.carrierDataList.length)
          })
          lengthArr.sort((a, b) => a-b)
          const max = lengthArr[lengthArr.length - 1]
          console.log('lengthArr==', lengthArr, max)

          this.standardCompareDynamicColumns = []
          for(let i=1; i<=max; i++){
            this.standardCompareDynamicColumns.push( i + $t('integration.month'))
          }

          this.getSpanArr2();//后台获取到数据后进行数据处理


        }
      })
    },

    // 合并单元格的逻辑
    getSpanArr2(){
      this.standardSpanArr = [] // 用于存放每一行记录的合并数
      for(let i=0; i<this.standardCompareList.length; i++){
        if(i === 0){
          // for(let j=0; j<this.colLength; j++){
          //   this.standardSpanArr[j] = {
          //     rowspan: 1,
          //     colspan: 1
          //   }
          // }


          this.standardSpanArr.push(1);
          this.standardPos = 0
        }else{
          // for(let j=0; j<this.colLength; j++){
          //   if(this.standardCompareList[i][j] === this.standardCompareList[i-1][j]){
          //     this.standardSpanArr[i * this.colLength + j ] = {
          //       rowspan: 2,
          //       colspan: 1
          //     }
          //   }else{
          //     this.standardSpanArr[i * this.colLength + j ] = {
          //       rowspan: 1,
          //       colspan: 1
          //     }
          //   }
          // }
          if (this.standardCompareList[i].carrierId === this.standardCompareList[i - 1].carrierId) {
            this.standardSpanArr[this.standardPos] += 1;
            this.standardSpanArr.push(0);
          } else {
            this.standardSpanArr.push(1);
            this.standardPos = i;
          }
        }
      }
      console.log('this.standardSpanArr==', this.standardSpanArr)
    },
    objectSpanMethod2({ row, column, rowIndex, columnIndex }) {
      if(columnIndex===0 || columnIndex===1 || columnIndex===2){
        const _row = this.standardSpanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        }
      }
      // return this.standardSpanArr[rowIndex * this.colLength + columnIndex]
    },

    // 客户列表
    getCustomer () {
      this.getCustomerList({
          type: 1,
          tab: 1
        }).then(({ result }) => {
        let list = []
        result.forEach((item, index) => {
          // 过滤出选择的客户
          if(this.sceneIds.findIndex(_ => _ === item.id) !== -1){
            list.push(item)
          }
        })
        this.scenesList = list
      })
    },


  }
}
</script>
<style lang="scss" scoped>
.echarts {
  // width: 50% !important;
  height: 250px !important;
}
.w-160 {
  width: 160px;
}
.w-80 {
  width: 80px;
}
.text_center {
  text-align: center;
}
.div_level1 {
  width: 160px;
  height: 40px;
  line-height: 40px;
  text-align: center;
}

::v-deep .el-table__cell {
  border-bottom: 1px solid #EBEEF5 !important;
}

</style>
